import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router";
import { Center, Loader } from "@mantine/core";
import TagForm from "../components/Settings/Tags/TagForm";
import { getTagById, TagKind } from "../api/tagApi";

const KINDS: TagKind[] = ["role", "skill"];

const UpdateTag = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [tag, setTag] = useState<any>(null);

  useEffect(() => {
    if (!id) return;
    const fetchData = async () => {
      const { data }: any = await getTagById({ id });
      setTag(data?.response ?? null);
    };
    fetchData();
  }, [id]);

  if (!tag) {
    return (
      <Center h={240}>
        <Loader color="#5C26FF" />
      </Center>
    );
  }

  // Etiketin türü kaydın kendisinden gelir; query parametresi sadece yedek.
  const raw = tag.kind ?? searchParams.get("kind");
  const kind: TagKind = KINDS.includes(raw as TagKind)
    ? (raw as TagKind)
    : "role";

  return (
    <TagForm
      kind={kind}
      initialTag={tag}
      onSaved={() => navigate(`/settings/tags?kind=${kind}`)}
    />
  );
};

export default UpdateTag;
